import { ComponentProps } from "@arelia-types/widget";
import { countBy } from "lodash";
import { useHqCustomersAPI } from "src/features/hq/customers/hq-customers.api";
import CustomerLocationsPresenter from "./CustomerLocationsPresenter";

export default function CustomerLocationsContainer({ config }: ComponentProps) {
  const { data: customers, isLoading } = useHqCustomersAPI();

  const customersCountries = customers?.filter(c => c.address?.includes(",&#160"))
    .map(c => c.address.split(",&#160")[1].trim());

  const countries = countBy(customersCountries)

  return (
    <CustomerLocationsPresenter
      countries={countries}
      loading={isLoading}
      id={config.id}
    />
  );
}
